import i18n from 'scoreboard/components/i18n'
import template from './my-tasks.hbs'
import FilteredList from '../filtered-list/filtered-list'
import orgRow from '../filtered-list/filtered-list-org-row.hbs'
import myTasksRow from './my-tasks-row.hbs'
import noTasks from './no-tasks.hbs'
import { shortenedAndUnshortened }  from 'scoreboard/components/format-value'
import moment from 'moment'
import _ from 'lodash'
import DataType from 'scoreboard/datasets/model/data-type'
import HomeNav from '../home-nav'
import { isV5 } from 'scoreboard/components/version'
const { PERCENT, CURRENCY } = DataType

function getDisplayHeading() {
	return i18n.get('bookmarks.home.myTasks')
}

var MyTasks = FilteredList.extend({

	_template: template,

	_countKeyPrefix: 'initiatives.tasks.number',

	_filterIcon: 'initiatives',

	_displayHomeNav: true,

	heading: getDisplayHeading,

	className: 'filtered-list home my-tasks panes table-hack display-layout scroll-layout-xy',

	emptyTemplate: noTasks,

	initialize: function(options = {}) {
		options.sortOptions = {
			fields: ['label', 'aggregatedStartDate', 'aggregatedEndDate', 'percentComplete', 'budgetSpent', 'aggregatedBudget'],
			numeric: ['aggregatedStartDate', 'aggregatedEndDate', 'percentComplete', 'budgetSpent', 'aggregatedBudget'],
			extractSortData: (init, field) => {
				if  (field != 'aggregatedStartDate' && field != 'aggregatedEndDate') {
					return init[field]
				}
				return _.isNil(init[field]) ? null : moment(init[field]).valueOf()
			}
		}
		FilteredList.prototype.initialize.call(this, options)
	},

	renderHomeNav: function(container) {
		if (isV5()) {
			return
		}
		this.homeNav = new HomeNav({
			section: 'my-tasks'
		})
		container.prepend(this.homeNav.el)
		this.homeNav.render()
	},

	_renderObject: function(init) {
		var html = ''
		,	percentComplete = shortenedAndUnshortened({ value: init.percentComplete, dataType: PERCENT })
		,	budgetSpent = shortenedAndUnshortened({ value: init.budgetSpent, dataType: CURRENCY, currencyCode: init.currencyCode })
		,	totalBudget = shortenedAndUnshortened({ value: init.aggregatedBudget, dataType: CURRENCY, currencyCode: init.currencyCode })

		html += myTasksRow({
			id: init.id,
			label: init.label,
			startDate: init.aggregatedStartDate,
			dueDate: init.aggregatedEndDate,
			iconName: init.type,
			colorClasses: 'icon-task color-icon ' + (init.color || ''),
			percentComplete: percentComplete.shortened,
			percentCompleteUnshortened: percentComplete.unshortened != percentComplete.shortened ? percentComplete.unshortened : null,
			budgetSpent: budgetSpent.shortened,
			budgetSpentUnshortened: budgetSpent.unshortened != budgetSpent.shortened ? budgetSpent.unshortened : null,
			totalBudget: totalBudget.shortened,
			totalBudgetUnshortened: totalBudget.unshortened != totalBudget.shortened ? totalBudget.unshortened : null
		})
		return html
	},

	_getColor: function(init) {
		return init.color
	},

	_orgRowMeta: _.memoize(function() {
		return {
			template: orgRow,
			colspan: 6
		}
	}),

	remove: function() {
		FilteredList.prototype.remove.apply(this, arguments)
		_.invokeMap([this.nonAbbreviatedTooltip], 'remove')
	}
})

export default MyTasks

MyTasks.__filename__ = 'home/my-tasks/my-tasks.js'
